declare namespace $ {

	type $mol_text__text_shm_projects_configuration_1 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['session_directory'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_projects_configuration_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_configuration_3 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['Session_directory'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_text__text_shm_projects_configuration_4 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['session_agents'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_projects_configuration_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_configuration_6 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['Session_agents'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type __shm_projects_configuration_7 = $mol_type_enforce<
		Parameters< $shm_projects_configuration['node_expanded'] >[0]
		,
		Parameters< ReturnType< $shm_projects_configuration['Tree'] >['expanded'] >[0]
	>
	type __shm_projects_configuration_8 = $mol_type_enforce<
		Parameters< $shm_projects_configuration['node_expanded'] >[1]
		,
		Parameters< ReturnType< $shm_projects_configuration['Tree'] >['expanded'] >[1]
	>
	type $shm_tree__roots_shm_projects_configuration_9 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_roots'] >
		,
		ReturnType< $shm_tree['roots'] >
	>
	type $shm_tree__children_shm_projects_configuration_10 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_children'] >
		,
		ReturnType< $shm_tree['children'] >
	>
	type $shm_tree__expanded_default_shm_projects_configuration_11 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_expanded_default'] >
		,
		ReturnType< $shm_tree['expanded_default'] >
	>
	type $shm_tree__expanded_key_shm_projects_configuration_12 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_expanded_key'] >
		,
		ReturnType< $shm_tree['expanded_key'] >
	>
	type $shm_tree__Item_shm_projects_configuration_13 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['Node'] >
		,
		ReturnType< $shm_tree['Item'] >
	>
	type $mol_form__form_fields_shm_projects_configuration_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__submit_title_shm_projects_configuration_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['submit_title'] >
	>
	type $mol_form__message_done_shm_projects_configuration_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['message_done'] >
	>
	type $mol_form__save_shm_projects_configuration_17 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['save'] >
		,
		ReturnType< $mol_form['save'] >
	>
	type $mol_textarea__value_shm_projects_configuration_18 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_string'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_number__value_shm_projects_configuration_19 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_number'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_textarea__hint_shm_projects_configuration_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_projects_configuration_21 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_list'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_shm_projects_configuration_22 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_configuration_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_projects_configuration_24 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_configuration_25 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['Text'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form_field__name_shm_projects_configuration_26 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_configuration_27 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['Number'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_projects_configuration_28 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_label'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_projects_configuration_29 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_boolean'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_form_field__name_shm_projects_configuration_30 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['node_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_configuration_31 = $mol_type_enforce<
		ReturnType< $shm_projects_configuration['List'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	export class $shm_projects_configuration extends $mol_page {
		session_directory( ): string
		Session_directory( ): $mol_text
		Session_directory_field( ): $mol_form_field
		session_agents( ): string
		Session_agents( ): $mol_text
		Session_agents_field( ): $mol_form_field
		node_roots( ): readonly(any)[]
		node_children( id: any): readonly(any)[]
		node_expanded( id: any, next?: ReturnType< ReturnType< $shm_projects_configuration['Tree'] >['expanded'] > ): ReturnType< ReturnType< $shm_projects_configuration['Tree'] >['expanded'] >
		node_expanded_default( id: any): boolean
		node_expanded_key( id: any): string
		Tree( ): $shm_tree
		save( next?: any ): any
		Form( ): $mol_form
		node_content( id: any): readonly(any)[]
		node_label( id: any): string
		node_string( id: any, next?: string ): string
		Text( id: any): $mol_textarea
		node_number( id: any, next?: number ): number
		Number( id: any): $mol_number
		node_boolean( id: any, next?: boolean ): boolean
		node_list( id: any, next?: string ): string
		List( id: any): $mol_textarea
		project_id( ): string
		title( ): string
		body( ): readonly(any)[]
		Node( id: any): $mol_view
		Node_title( id: any): $mol_view
		Text_field( id: any): $mol_form_field
		Number_field( id: any): $mol_form_field
		Boolean( id: any): $mol_check_box
		List_field( id: any): $mol_form_field
	}
	
}

//# sourceMappingURL=configuration.view.tree.d.ts.map